import React from 'react';
import ReactDOM from 'react-dom';
//import XfinityList from './XfinityList.js';
//import ChargerDevicesList from './ChargerDevicesList.js';
import ChargerWifiList from './ChargerWifiList.js';

/**
 * Wait for an element before resolving a promise
 * @param {String} querySelector - Selector of element to wait for
 * @param {Integer} timeout - Milliseconds to wait before timing out, or 0 for no timeout              
 */
function waitForElement(querySelector, timeout=0){
  const startTime = new Date().getTime();
  return new Promise((resolve, reject)=>{
      const timer = setInterval(()=>{
          const now = new Date().getTime();
          if(document.querySelector(querySelector)){
              clearInterval(timer);
              resolve();
          }else if(timeout && now - startTime >= timeout){
              clearInterval(timer);
              reject();
          }
      }, 100);
  });
}

waitForElement("#react-chargerWifi-list", 3000).then(function(){
  try {
    ReactDOM.render(
      <ChargerWifiList />,
      document.getElementById("react-chargerWifi-list")
    );
  } catch (error) {
    console.log('[SupportedDevices Error]', error)
  }
}).catch((error)=>{
  console.log('[SupportedDevices Error]', error);
});